module.exports = __webpack_public_path__ + "img/pr_6.e2af3692.png";